import React from "react";

import Form from "ui/Form";
import Panel from "ui/Panel";
import PanelSection from "ui/PanelSection";
import { useRoutes } from "utils/routes";

import { ServerSettingsQuery } from "../gql/Query.generated";
type FullServerType = ServerSettingsQuery["getServerDetails"];

type Props = {
  server: FullServerType;
  organizationPlanName: string;
  permittedToEditServer: boolean;
};

const EditForm: React.FunctionComponent<Props> = ({
  server,
  organizationPlanName,
  permittedToEditServer,
}) => {
  const { server: serverRoute } = useRoutes();
  if (!permittedToEditServer) {
    return (
      <Panel title="Server Settings">
        <PanelSection>
          You are not allowed to edit this server - you need the{" "}
          <strong>Modify</strong> permission on the server.
        </PanelSection>
      </Panel>
    );
  }

  const { humanId, name, retentionInDays } = server;

  return (
    <Panel title="Server Settings">
      <Form action={serverRoute(humanId)} method="patch">
        <div className="form-group">
          <label className="control-label" htmlFor="server_name">
            Identifier
          </label>
          <div className="row">
            <div className="col-sm-5">
              <input
                className="form-control"
                type="text"
                defaultValue={name}
                name="server[name]"
                id="server_name"
              />
            </div>
            <div className="col-sm-6">
              <div className="help-block">
                Choose a descriptive name of your choice
              </div>
            </div>
          </div>
        </div>
        <div className="form-group">
          <label className="control-label" htmlFor="retention-time">
            Statistics Retention Time
          </label>
          <div className="row">
            <div className="col-sm-5">
              <input
                id="retention-time"
                className="form-control"
                disabled
                type="text"
                defaultValue={`${retentionInDays} days`}
              />
            </div>
            <div className="col-sm-7">
              <div className="help-block">{organizationPlanName} plan</div>
            </div>
          </div>
        </div>
        <div className="form-group">
          <input
            type="submit"
            name="commit"
            value="Save Settings"
            className="btn btn-success"
            data-disable-with="Save Settings"
          />
        </div>
      </Form>
    </Panel>
  );
};

export default EditForm;
